<template>
  <div :class="{ 'max-width-100': menu && $vuetify.breakpoint.smOnly }">
    <v-layout
      column
      class="wrapper"
      :class="{ 'dark': dark }"
      align-end
      :align-center="menu && $vuetify.breakpoint.smAndDown">
      <span class="summary-title">{{ $t('order.my_order') }}</span>
      <span class="amount">{{ totalStr }}</span>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moneyFormatMixins from '@/mixins/MoneyFormat'

export default {
  props: {
    dark: Boolean,
    menu: Boolean
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters({
      total: 'cart/total'
    }),
    exchangeCurrency () {
      return this.cart.selectedCurrency
    },
    totalStr () {
      return this.exchangeCurrency
        ? this.formatAmount(this.total / this.exchangeCurrency.exchangeRate) + ' ' + this.exchangeCurrency.currency.name
        : ''
    }
  },
  created () {
    const selectedCurrency = localStorage.getItem('selectedCurrency')
    if (selectedCurrency) {
      this.selectedCurrency = JSON.parse(selectedCurrency)
    }
  },
  mixins: [moneyFormatMixins]
}
</script>

<style lang="scss" scoped>
.wrapper {
  color: var(--v-primary-base);
  & .dark {
    color: white;
  }
  text-align: center;
}
span {
  line-height: normal;
}
.summary-title {
  text-transform: uppercase;
  @media (max-width: 660px) {
    font-size: 13px;
  }
}
.amount {
  font-size: 20px;
  font-weight: 1000;
}
</style>
